/**
 * The cheapest delivery option, which is the one the storefront presents as the default: it is
 * what "or faster" in the collapsed PDP line is measured against, and the threshold it carries is
 * the one the free-shipping badge advertises.
 *
 * Price rather than name, because the service no longer returns tier names the storefront can
 * match on - NSHIFT titles are carrier-specific ("UPS Express", "PostNord").
 */
export const getCheapestShippingOption = (options: ShippingOption[]): ShippingOption | undefined =>
  options.reduce<ShippingOption | undefined>(
    (cheapest, option) =>
      // A price tie goes to the slower option: never promise a date we might not keep.
      !cheapest ||
      option.price < cheapest.price ||
      (option.price === cheapest.price && option.maxDays > cheapest.maxDays)
        ? option
        : cheapest,
    undefined
  );
